// CRA embeds this public URL at build time. Tests do not load development env files.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "test" ? "http://localhost:8080" : "")
).trim().replace(/\/+$/, "");

if (!API_BASE_URL) {
  throw new Error("REACT_APP_API_BASE_URL must be set before starting or building the frontend.");
}
